'use client'

import { useTheme, Image } from "tamagui";

export function LockIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={100/5} height={113/5} viewBox="0 0 15 17" {...props}>
			<g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
				<g id="lock-(1)" transform="translate(1.250000, 1.250000)" stroke="var(--color)" stroke-width="1.5">
					<path d="M0,7 C0,6.4477 0.44772,6 1,6 L11.5,6 C12.0523,6 12.5,6.4477 12.5,7 L12.5,12.5 C12.5,13.6046 11.6046,14.5 10.5,14.5 L2,14.5 C0.89543,14.5 0,13.6046 0,12.5 L0,7 Z" id="Path" fill="var(--color)"></path>
					<path d="M2,5.75 L2,5.5927 C2,4.03147 1.90607,2.29125 2.99646,1.1739 C3.61829,0.5367 4.6245,0 6.25,0 C7.8755,0 8.8817,0.5367 9.5035,1.1739 C10.5939,2.29125 10.5,4.03147 10.5,5.5927 L10.5,5.75" id="Path"></path>
				</g>
			</g>
		</svg>
	)
}
